module.exports = __webpack_public_path__ + "img/sam-shirt-pride-03.8cdac9a4.jpg";